import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  EventEmitter
} from "@angular/core";
import { PickingProductivityService, isEmptyObject } from "../../../core";
import { BehaviorSubject } from "rxjs";
import moment from "moment";

@Component({
  standalone: false,
  selector: "app-picking-productivity-content",
  templateUrl: "./picking-productivity-content.component.html",
  styleUrls: ["./picking-productivity-content.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class PickingProductivityContentComponent implements OnInit {
  /**
   * Range date list of picking productivity content component
   */
  rangeDateList: string[] = [];
  /**
   * Columns  of picking productivity content component
   */
  columns: any[] = [];
  /**
   * Determines whether detail has
   */
  hasDetail = false;
  /**
   * Input  of picking productivity content component
   */
  hasAccumulated = true;
  /**
   * Input  of picking productivity content component
   */
  accumulated: any[];
  /**
   * Input  of picking productivity content component
   */
  accumulatedTotal: any[];
  /**
   * Detail  of picking productivity content component
   */
  accumulatedDetail: any[] = [];
  /**
   * Output  of picking productivity content component
   */
  clickDetail: EventEmitter<any> = new EventEmitter();
  /**
   * Search filter of picking productivity component
   */
  @Input() searchFilter = new BehaviorSubject(undefined);
  /**
   * Input  of picking productivity content component
   */
  @Input() changeFilter = new BehaviorSubject(undefined);
  /**
   * Creates an instance of picking productivity content component.
   * @param pickingProductivityService PickingProductivityService
   */
  constructor(private pickingProductivityService: PickingProductivityService) {}
  /**
   * on init
   */
  ngOnInit() {
    /**
     * Event change in filter
     */
    // this.changeFilter.subscribe((res: any) => {
    //   this.hasAccumulated = true;
    //   this.hasDetail = false;
    //   this.accumulated = [];
    //   this.accumulatedDetail = [];
    // });
    /**
     * Event click search filter
     */
    this.searchFilter.subscribe((res: any) => {
      if (res) {
        this.initialization();
        this.rangeDateList = this.getRangeDate(res.dateInitial, res.dateFinal);
        if (this.rangeDateList.length === 1) {
          this.hasAccumulated = false;
          this.showDetailAccumulated(res);
        } else {
          this.showAccumulated(res);
        }
      }
    });
  }
  /**
   * Determines whether opened on
   */
  onOpened() {
    this.hasDetail = false;
  }
  /**
   * Determines whether click detail on
   */
  onOpenedDetail() {
    if (!this.hasDetail) {
      this.accumulatedTotal = this.accumulated.filter(x => x.active);
      this.hasDetail = true;
      const value = this.searchFilter.value;
      this.showDetailAccumulated(value);
    }
  }
  /**
   * Initializations picking productivity content component
   */
  private initialization() {
    this.hasAccumulated = true;
    this.hasDetail = false;
    // this.accumulated = [];
    this.accumulatedDetail = [];
  }
  /**
   * Shows accumulated
   * @param value any
   */
  private showAccumulated(value: any) {
    this.pickingProductivityService
      .getAccumulated(isEmptyObject(value))
      .subscribe((res: any) => {
        this.accumulated = res;
      });
  }
  /**
   * Shows detail accumulated
   * @param value any
   */
  private showDetailAccumulated(value: any) {
    const params: any = {};
    params.entityIds = value.entityIds.split(":");
    params.dateStart = value.dateInitial;
    params.dateEnd = value.dateFinal;
    params.dateLeadTimeDetailDtoList = this.rangeDateList;
    this.pickingProductivityService
      .getDetailAccumulated(isEmptyObject(params))
      .subscribe((res: any) => {
        this.accumulatedDetail = res;
      });
  }
  /**
   * Gets range date
   * @param dateStart string
   * @param dateEnd string
   * @returns any[]
   */
  private getRangeDate(dateStart: string, dateEnd: string) {
    let dateArr = [];
    const prevDate = moment(dateStart, "DD-MM-YYYY");
    const nextDate = moment(dateEnd, "DD-MM-YYYY");

    let start = new Date(prevDate.format());
    const end = new Date(nextDate.format());

    if (prevDate.format() === nextDate.format()) {
      dateArr.push(this.getNewDateByValue(start));
      return dateArr;
    }

    while (start <= end) {
      dateArr.push(this.getNewDateByValue(start));
      start = new Date(start.setDate(start.getDate() + 1));
    }
    return dateArr;
  }
  /**
   * Gets new date by value
   * @param valueDate Date
   * @returns any
   */
  private getNewDateByValue(valueDate: Date) {
    const date = moment(valueDate);
    const newDate: any = {};
    newDate.date = date.format("DD-MM-YYYY");
    newDate.day = Number(date.format("D"));
    newDate.month = Number(date.format("M"));
    newDate.year = Number(date.format("Y"));
    return newDate;
  }
}
